import { render, staticRenderFns } from "./RegistrationFaxFormGroup.vue?vue&type=template&id=545305d4&"
import script from "./RegistrationFaxFormGroup.vue?vue&type=script&lang=js&"
export * from "./RegistrationFaxFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/registration.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cforms%5Cregistration%5CRegistrationFaxFormGroup.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports